import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import App from './routes/App';
import { Provider } from 'react-redux';
import { store } from './utils/store';
// import registerServiceWorker from "./registerServiceWorker";
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/scss/particles-bluegrey.scss';
// import './styles/css/particles.css';
import './styles/css/provenance.css';
// import './styles/scss/index.scss';
import './styles/scss/darkmode.scss';

import 'material-design-icons-iconfont/dist/material-design-icons.css';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

import i18n from './i18n'; // initialized i18next instance
import helper from './utils/helper';

const appVersion = localStorage.getItem('version');
const _version = '0.0.7';
if (appVersion !== _version) {
  localStorage.removeItem('userInfo');
  localStorage.removeItem('userProfile');
  localStorage.removeItem('departmentSettings');
  localStorage.setItem('version', _version);
  // helper.clearSiteCache();
}
ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <React.Fragment>
        <App />
        <NotificationContainer />
      </React.Fragment>
    </I18nextProvider>
  </Provider>,
  document.getElementById('root'),
);
// registerServiceWorker();
